import type React from "react";

import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const PerformanceSummarySkeleton: React.FC = () => {
  return (
    <SkeletonLayout
      layout={{
        type: "row",
        spacing: 4,
        alignItems: "center",
        children: [
          {
            type: "column",
            sx: { flex: "1 1 auto" },
            alignItems: "center",
            justifyContent: "center",
            height: 300,
            children: [{ type: "skeleton", variant: "circular", width: 220, height: 220 }],
          },
          {
            type: "column",
            spacing: 1,
            sx: { flex: "1 1 120px" },
            children: [
              { type: "skeleton", variant: "rounded", height: 72, width: 120 },
              { type: "skeleton", variant: "rounded", height: 72, width: 120 },
              { type: "skeleton", variant: "rounded", height: 72, width: 120 },
              { type: "skeleton", variant: "rounded", height: 72, width: 120 },
              { type: "skeleton", variant: "rounded", height: 72, width: 120 },
              { type: "skeleton", variant: "rounded", height: 72, width: 120 },
            ],
          },
        ],
      }}
    />
  );
};
